import { Grid, Typography } from "@mui/material";
import MuiTooltip from "@mui/material/Tooltip";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';


const Tooltip = ({ data }) => {

  return (
    <>
        <Grid container direction="row" alignItems="center" columnSpacing={1}>
            <Grid item>
                <Typography>{data.cardTitle}</Typography>
            </Grid>
            <Grid item>
                <MuiTooltip disableFocusListener title={data.tooltipText}>
                    <InfoOutlinedIcon fontSize="small"/>
                </MuiTooltip>
            </Grid>
        </Grid>
    </>
  );

};

export default Tooltip;
